<template>
  <div class="p-home">
    <div class="g-header">
      <div class="bar">
        <div class="prepend">
          <svg-icon name="friendster" style="font-size: 60px"></svg-icon>
          <div class="online-num" title="在线人数">
            <svg-icon name="onlineNum" title="在线人数"></svg-icon>
            <span>{{ onlineNum }}</span>
          </div>
        </div>
        <div class="user" @click="showInfoDialog(info)">
          <i class="el-icon-user-solid"></i>
        </div>
      </div>
      <div class="tab-bar">
        <el-tabs @tab-click="changeTabHandle" :value="tabIndex">
          <el-tab-pane label="大厅"></el-tab-pane>
          <el-tab-pane>
            <span slot="label">
              私聊
              <span v-if="unreadNum" class="unread">{{ unreadNum }}</span>
            </span>
          </el-tab-pane>
        </el-tabs>
        <i @click="link({ path: '/search?keyword=&type=' })" class="el-icon-search"></i>
      </div>

      <van-notice-bar
        v-if="broadcast.msgId"
        wrapable
        :scrollable="false"
        class="twinkling"
        left-icon="volume-o"
        @click="link({ path: 'detail', query: { id: broadcast.msgId } })"
      >
        <p class="broadcast-content">{{ broadcast.txt }}</p>
      </van-notice-bar>
    </div>
    <div v-show="tabIndex === '0'" class="scroll-body">
      <ul class="infinite-list" ref="messageList" style="overflow:auto">
        <li ref="message" v-for="item in messageList" :key="item.msgId">
          <template v-if="item.type">
            <div class="sys-info">
              <span> {{ item.txt }}</span>
            </div>
          </template>
          <template v-if="item.msgType === 3">
            <money-message :info="item" @click-btn="bubbleClickHandle"></money-message>
          </template>
          <template v-else-if="item.msgType === 6">
            <ai-message :info="item"></ai-message>
          </template>
          <template v-else>
            <bubble-message :info="item" @click-btn="bubbleClickHandle" @withdraw="withdraw"></bubble-message>
          </template>
        </li>
      </ul>
      <div class="scroll-tip">
        <el-button v-if="!inBottom" @click="scrollBottom" size="small" style="color: #67C23A"> <i class="el-icon-download"></i>回到最新位置 </el-button>
        <transition name="fade" mode="out-in" v-else>
          <div class="online-shower" v-if="showOnline">
            <i class="van-icon van-icon-volume-o"></i>
            <div>
              <p>{{ onlineShower.companyName }}</p>
              <div style="display: flex;justify-content: space-between;">
                <span>{{ onlineShower.userName }}</span>
                <span style="color: #9CCC65;">上线啦~</span>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div v-show="tabIndex === '1'" class="scroll-body" :style="{ paddingBottom: '0px', paddingTop: broadcast.msgId ? '114px' : '70px' }">
      <conversation-list></conversation-list>
    </div>
    <div class="g-footer" v-if="tabIndex === '0'">
      <edit-box :is-private="false" :reply.sync="reply" :ats.sync="ats" @send="sendMessage"></edit-box>
    </div>
    <el-dialog width="90%" :show-close="false" :visible.sync="infoVisible" custom-class="info-dialog">
      <user-info v-if="infoVisible" :prop-info="propInfo"></user-info>
    </el-dialog>
  </div>
</template>

<script>
import EditBox from "@/components/EditBox";
import BubbleMessage from "@/components/BubbleMessage";
import MoneyMessage from "@/components/MoneyMessage";
import AiMessage from "@/components/AIMessage";
import Bus from "@/components/Bus";
import UserInfo from "@/components/dialog/UserInfo";
import { mapMutations, mapState } from "vuex";
import Tags from "@/components/tags";
import Chat from "@/api/chat";
import ConversationList from "@/components/ConversationList";

export default {
  name: "Home",
  data() {
    return {
      inBottom: true,
      ats: [],
      logId: "",
      propUserId: "",
      propInfo: {},
      infoVisible: false,
      reply: { id: "", txt: "" },
      nickName: "",
      tabs: [
        {
          label: "大厅",
          value: ""
        },
        {
          label: "私聊"
        }
      ],
      loading: false,
      onlineShower: {
        userId: "",
        userName: "",
        companyId: "",
        companyName: ""
      },
      showOnline: false,
      pageSize: 50,
      timer: ""
    };
  },
  components: { EditBox, BubbleMessage, MoneyMessage, AiMessage, UserInfo, ConversationList },
  computed: {
    ...mapState({
      messageList: state => state.messageList,
      token: state => state.token,
      userId: state => state.userId,
      broadcast: state => state.broadcast,
      onlineList: state => state.onlineList,
      onlineNum: state => state.onlineNum,
      info: state => state.info,
      tabIndex: state => state.tabIndex,
      chatScroll: state => state.chatScroll,
      unreadNum() {
        return this.$store.getters.unreadNum;
      }
    }),
    searchTypes() {
      const searchTypes = [
        {
          label: "@我",
          value: "at"
        },
        {
          label: "我的",
          value: "mine"
        }
      ];
      Tags.map(item => searchTypes.push(item));
      searchTypes.push({
        label: "红包",
        value: "redEnvelope"
      });
      return searchTypes;
    }
  },
  watch: {
    // token改变时初始化
    token: {
      immediate: true,
      handler(newValue) {
        if (!newValue) {
          return false;
        }
        clearInterval(this.timer);
        this.showOnlineHandle();
        this.timer = setInterval(() => {
          this.showOnlineHandle();
        }, 2000 + Math.random() * 5000);
        Chat.getOnline().then(res => {
          this.setOnlineNum(res.OnlineCount);
        });
        if (this.messageList.length === 0) {
          this.more({ scroll: false });
        }
      }
    },
    // 大厅消息更新，如果用户滚动条在底部则滚动到最新消息
    messageList() {
      if (this.inBottom) {
        this.$nextTick(() => this.scrollBottom());
      }
    }
  },
  methods: {
    ...mapMutations(["addToMessageList", "addOnline", "getOnline", "shiftOnline", "setOnlineNum", "setTabIndex"]),
    // 切换聊天和私聊的tab
    changeTabHandle() {
      if (this.tabIndex === "1") {
        this.setTabIndex("0");
        this.$nextTick(() => {
          this.scrollBottom();
        });
      } else {
        this.setTabIndex("1");
        Bus.$emit("getConversations");
        this.$store.commit("setChatScroll");
      }
    },
    // 个人信息的Dialog
    showInfoDialog(info) {
      this.propInfo = info;
      this.infoVisible = true;
    },
    // 监听发送消息，往APP的监听传
    sendMessage(message) {
      Bus.$emit("sendMessage", message);
    },
    // 监听撤回消息，往APP的监听传
    withdraw(msgId) {
      Bus.$emit("withdraw", msgId);
    },
    // 监听点击时间
    bubbleClickHandle(e) {
      if (e.type === "at") {
        const findItem = this.ats.find(item => item.at + item.atName === e.info.id + e.info.name);
        !findItem && this.ats.unshift({ at: e.info.id, atName: e.info.name, isAnonymous: e.info.isAnonymous });
      }

      if (e.type === "showInfo") {
        this.showInfoDialog(e.info);
      }

      if (e.type === "reply") {
        this.reply = {
          id: e.info.msgId,
          txt: e.info.txt
        };
      }
    },
    // 大厅需要记录滚动条位置，跳转的时候用这个方法
    link({ path, query }) {
      this.$store.commit("setChatScroll");
      this.$router.push({ path, query });
    },
    // 更多消息
    async more({ pageSize = this.pageSize, scroll = false } = {}) {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      const lastId = this.messageList[0] && this.messageList[0].msgId;
      const t = this.messageList[0] ? this.messageList[0].t : "";
      await Chat.search({
        t,
        msgId: lastId,
        pageSize,
        orderby: "time"
      }).then(response => {
        const list = response.ResultList;
        this.addToMessageList({ list });
        if (scroll) {
          this.$refs.message[lastId].scrollIntoView();
        }
        this.loading = false;
      });
    },
    scrollHandle() {
      const scrollTop = $(document).scrollTop();
      const scrollHeight = $(document).height();
      // 滚动条超过三分一时显示最新消息
      this.inBottom = scrollHeight - scrollTop <= 1200;
      if (scrollTop < 300 && this.tabIndex === "0") {
        this.more();
      }
    },
    showOnlineHandle() {
      this.showOnline = true;
      if (this.onlineList.length) {
        this.setOnlineNum();
        this.onlineShower = this.onlineList[0];
        setTimeout(() => {
          this.showOnline = false;
          this.shiftOnline();
        }, 1500);
      } else {
        this.showOnline = false;
      }
    },
    scrollBottom() {
      window.scrollTo(0, document.body.scrollHeight);
    }
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollHandle, true);
    clearInterval(this.timer);
  },
  mounted() {
    $(document).scrollTop(this.chatScroll);
    document.addEventListener("scroll", this.scrollHandle, true);
  }
};
</script>
<style lang="scss">
.p-home {
  background-color: #f0f3f8;

  .scroll-body {
    padding-top: 70px;
    padding-bottom: 90px;
    position: relative;
    min-height: 100vh;
    overflow: auto;
  }

  .el-divider__text {
    background-color: #f5f5f5;
  }
  .online-num {
    display: flex;
    margin-left: 10px;
    align-items: center;

    span {
      margin-left: 5px;
      color: #9ccc65;
    }
  }
  .el-tabs {
    padding-left: 10px;
    display: flex;
    align-items: center;
    .el-tabs__nav-wrap::after {
      background-color: transparent;
    }
    .el-tabs__item {
      display: inline-flex;
      align-items: center;
      height: 30px;
      padding: 0 10px;
      font-size: 12px;
      font-weight: normal;
    }
  }
  .g-header {
    .bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 5px 0 10px;
      height: 32px;
      background-color: #5e5e5e;
      .prepend {
        display: flex;
        align-items: center;

        span {
          display: inline-flex;
          align-items: center;
          line-height: 16px;
          font-size: 12px;
        }
      }

      .user {
        cursor: pointer;
        color: #fff;
      }
    }
    .tab-bar {
      display: flex;
      padding-right: 5px;
      justify-content: space-between;
      align-items: center;
    }
  }

  .infinite-list {
    padding: 0 10px;
  }

  .sys-info {
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: 12px;

    > span {
      display: block;
      padding: 5px;
      border-radius: 4px;
      background-color: #eee;
      color: #666;
    }
  }

  .scroll-tip {
    position: fixed;
    bottom: 100px;
    right: 5px;
    z-index: 10;

    .online-shower {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 2px;
      padding: 6px;
      font-size: 12px;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.6);

      i {
        font-size: 14px;
        padding-right: 4px;
      }
    }
  }
}

.scroll-text {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 20px;
  font-size: 12px;
  white-space: nowrap;
  background-color: #ee7700;

  .animate {
    margin-right: 50px;
    font-size: 12px;
    color: #fff;
    display: inline-block;
    white-space: nowrap;
    animation: 10s wordsLoop linear infinite normal;
  }

  @keyframes wordsLoop {
    0% {
      transform: translateX(10%);
    }
    100% {
      transform: translateX(-100%);
    }
  }
}

.twinkling {
  .van-icon {
    animation: twinkling 0.5s infinite linear;
  }

  @keyframes twinkling {
    0% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 100ms;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
}
</style>
